/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePlanTimeEntryRequest
 */
export interface CreatePlanTimeEntryRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePlanTimeEntryRequest
     */
    taskId: string;
    /**
     * 
     * @type {Date}
     * @memberof CreatePlanTimeEntryRequest
     */
    loggedDate: Date;
    /**
     * 
     * @type {number}
     * @memberof CreatePlanTimeEntryRequest
     */
    hours: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanTimeEntryRequest
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanTimeEntryRequest
     */
    notes?: string;
}

/**
 * Check if a given object implements the CreatePlanTimeEntryRequest interface.
 */
export function instanceOfCreatePlanTimeEntryRequest(value: object): value is CreatePlanTimeEntryRequest {
    if (!('taskId' in value) || value['taskId'] === undefined) return false;
    if (!('loggedDate' in value) || value['loggedDate'] === undefined) return false;
    if (!('hours' in value) || value['hours'] === undefined) return false;
    return true;
}

export function CreatePlanTimeEntryRequestFromJSON(json: any): CreatePlanTimeEntryRequest {
    return CreatePlanTimeEntryRequestFromJSONTyped(json, false);
}

export function CreatePlanTimeEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePlanTimeEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['taskId'],
        'loggedDate': (new Date(json['loggedDate'])),
        'hours': json['hours'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CreatePlanTimeEntryRequestToJSON(json: any): CreatePlanTimeEntryRequest {
    return CreatePlanTimeEntryRequestToJSONTyped(json, false);
}

export function CreatePlanTimeEntryRequestToJSONTyped(value?: CreatePlanTimeEntryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskId': value['taskId'],
        'loggedDate': ((value['loggedDate']).toISOString().substring(0,10)),
        'hours': value['hours'],
        'userId': value['userId'],
        'notes': value['notes'],
    };
}

